module.exports = __webpack_public_path__ + "img/message-dollar.27729e0c.svg";